import { Group } from '@shure/cloud/shared/models/devices';

import { GroupFragment } from '../graphql/generated/cloud-sys-api';

export function mapGroupFromSysApi(group: GroupFragment | null | undefined): Group | undefined {
	if (!group) {
		return undefined;
	}

	return {
		id: group.id,
		name: group.name,
		health: {
			worstSeverity: group.health.worstSeverity ?? undefined
		},
		parentId: group.parent?.id
	};
}
